import { defineComponent as _defineComponent } from 'vue'
import EprintCashlessTag from '@/components/format-edit/eprint/EprintCashlessTag.vue'
import { useEprintSession } from '@/composables/format-edit/useEprintSession'
import {
  getOptionClass,
  getOptionLabel,
  getSevenElevenPriceMemo,
  isCashlessSupported,
  selectedStyle,
  type EprintPrintOption
} from '@/utils/format-edit/eprintOptions'


export default /*#__PURE__*/_defineComponent({
  __name: 'EprintPrintOptionRadio',
  props: {
    option: null
  },
  emits: ['click-option'],
  setup(__props: any) {





const session = useEprintSession()

return { __sfc: true,session, EprintCashlessTag, getOptionClass, getOptionLabel, getSevenElevenPriceMemo, isCashlessSupported, selectedStyle }
}

})